import { useState, useEffect } from 'react';

// Hook that returns a boolean value indicating whether the target element is in the viewport

export const useIntersection = (targetRefs) => {
  const [currentIntersections, setCurrentIntersections] = useState({});
  const [lastIntersection, setLastIntersection] = useState(null);
  useEffect(() => {
    const intersectionMap = targetRefs.reduce((acc, ref) => {
      if (ref.current && !acc[ref.current.id]) {
        acc[ref.current.id] = false;
      }
      return acc;
    }, currentIntersections);
    setCurrentIntersections(intersectionMap);
  }, [targetRefs.current]);
  

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setLastIntersection((previous) => {
          if (entry.isIntersecting) {
            return entry.target.id;
          }
          return previous;
        });
      },
      { threshold: 0.5 }
    );

    targetRefs.forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      targetRefs.forEach((ref) => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });

      observer.disconnect();
    };
  }, [targetRefs]);

  return lastIntersection;
};
